module.exports = __webpack_public_path__ + "static/media/comment-icon.04103dd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comment-icon.svg
// module id = 830
// module chunks = 0